export class PropertyPatch {
  PropertyName: string;
  PropertyValue: string;
}
